module.exports = __webpack_public_path__ + "img/PRT.872c98ad.png";